import { useSelector } from 'react-redux'
import { createUseStyles, useTheme } from 'react-jss'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const Logo = ({
  tabIndex,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const strings = useSelector((state) => state.language.string)

  return (
    <div className={classes.root}>
      <DelayLink
        to={`/${window.pathSite || ''}`}
        className={classes.logo}
        tabIndex={tabIndex}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 90 16"
          width={theme.header.logo.width}
          height={theme.header.logo.height}
        >
          <title>{`${strings.site_title} Logo`}</title>
          <path d="M45.16.33h1.68v15.24h-1.65V3.64l-5.4 11.93h-1.24L33.17 3.64v11.93h-1.63V.33h1.94l5.79 12.82L45.16.33Zm5.12 15.24h9.32V14h-7.69V8.73h6.95V7.16h-6.95V1.9h7.69V.33h-9.32v15.24ZM61.46 1.9h5.01v13.67h1.63V1.9h5.01V.33H61.46V1.9Zm12.91 0h5.01v13.67h1.63V1.9h5.01V.33H74.37V1.9Zm14-1.57v15.24H90V.33h-1.63ZM28.75 7.95a7.95 7.95 0 1 1-15.902-.002 7.95 7.95 0 0 1 15.902.002Zm-1.61 0c0-3.5-2.84-6.34-6.34-6.34s-6.34 2.84-6.34 6.34 2.84 6.34 6.34 6.34 6.34-2.84 6.34-6.34Zm-1.51 0c0 2.67-2.16 4.83-4.83 4.83s-4.83-2.16-4.83-4.83 2.16-4.83 4.83-4.83 4.83 2.16 4.83 4.83Zm-1.12 0c0-2.05-1.66-3.71-3.71-3.71s-3.71 1.66-3.71 3.71 1.66 3.71 3.71 3.71 3.71-1.66 3.71-3.71Zm-1.52 0a2.19 2.19 0 1 1-4.379.001 2.19 2.19 0 0 1 4.379-.001Zm-.63 0c0-.86-.7-1.57-1.57-1.57s-1.57.7-1.57 1.57.7 1.57 1.57 1.57 1.57-.7 1.57-1.57ZM9.49 8.98c.44-.47.79-1.01 1.03-1.62.24-.61.36-1.27.36-1.95s-.12-1.34-.36-1.95c-.24-.61-.58-1.15-1.03-1.62C9.05 1.38 8.5 1 7.87.73 7.24.46 6.53.32 5.76.32H0v15.26h1.63V1.82h4.12c.53 0 1.02.1 1.44.28.42.19.79.45 1.09.78.3.33.53.72.7 1.15.16.43.24.89.24 1.37s-.08.96-.24 1.39c-.16.43-.4.81-.7 1.14-.3.33-.67.59-1.1.78-.42.19-.91.29-1.44.29H3.29l5.52 6.59h2.07l-4.32-5.16c.44-.06.86-.17 1.24-.34.64-.27 1.25-.64 1.69-1.11Z" />
        </svg>
      </DelayLink>
    </div>
  )
}

export default Logo
